export enum WINDOW_LOCATION_HOST {
  LOCALHOST = 'localhost:8000',
  LIVE = 'live.rcm-corporate-staging.dev.web.rcm.at',
  PREVIEW = 'preview.rcm-corporate-staging.dev.web.rcm.at',
  RCM = 'www.rcm.at',
  RCMI = 'www.rcm-international.com',
}

export enum JENTIS_CONFIG {
  LOCALHOST_DOMAIN = 'localhost-domain',
  LOCALHOST_ENV = 'localhost-env',
  LOCALHOST_SCRIPT = 'localhost-script',
  LIVE_DOMAIN = 'https://xw8mu7.live.rcm-corporate-staging.dev.web.rcm.at',
  LIVE_ENV = 'dev-rcm',
  LIVE_SCRIPT = '34e2ae',
  RCM_DOMAIN = 'https://9cf1a4.rcm.at',
  RCM_ENV = 'RCM',
  RCM_SCRIPT = 'koij3i',
  RCMI_DOMAIN = 'https://smpmq5.rcm-international.com',
  RCMI_ENV = 'rcm-international',
  RCMI_SCRIPT = 'qrw4gk',
}
